import React from 'react';
import {List, Datagrid, TextField, EditButton} from 'react-admin';

const ShowEditButton = ({record, basePath}) => {
  return record.id !== 0 && <EditButton basePath={basePath} record={record} />;
};
export const BannerList = (props) => (
  <List title=" Banner" {...props}>
    <Datagrid>
      <TextField source="bannerName" label="Banner Name" />
      <TextField source="bannerUrl" />
      <ShowEditButton />
    </Datagrid>
  </List>
);
export default BannerList;
